// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---gatsby-theme-intro-src-pages-404-js": () => import("./../../../../gatsby-theme-intro/src/pages/404.js" /* webpackChunkName: "component---gatsby-theme-intro-src-pages-404-js" */),
  "component---gatsby-theme-intro-src-templates-index-js": () => import("./../../../../gatsby-theme-intro/src/templates/index.js" /* webpackChunkName: "component---gatsby-theme-intro-src-templates-index-js" */)
}

